import { computed } from "vue";
import { useStore } from "vuex";
import { CANVAS_SETTINGS } from "@plugins/drawing/drawing.config";
import { IMAGE_ANNOTATION_DEFAULT_THICKNESS } from "@modules/annotation/service/annotation.constant";

/**
 * Role based default tool configuration of the image annotation tools.
 * Teacher: red, Student: black (same behaviour as the existing drawing tool).
 */
export function useImageAnnotationDefaults() {
  const store = useStore();

  const isTeacher = computed<boolean>(() => store.getters["auth/isTeacher"]);

  const defaultColor = computed<string>(() =>
    isTeacher.value
      ? CANVAS_SETTINGS.defaultColorForTeacher
      : CANVAS_SETTINGS.defaultColorForStudent,
  );

  const defaultThickness = IMAGE_ANNOTATION_DEFAULT_THICKNESS;

  return { defaultColor, defaultThickness };
}
